define('shared/initializer/form/newHouseAdapters/Member',[ 
    'shared/lib/ctor', 
    'shared/lib/RSVP',
    './Checkout', 
    './mixins/EFIDUserCreatable',
    './mixins/SubscriptionsSavable',
    './mixins/MemberCreatable',
    './mixins/UpdateMemberInfoInMemberPage',
    './mixins/MemberRedemptionCodeConsumable',
    '../adapters/mixins/EmailRegistrationValidatable',
    '../adapters/mixins/HasRedemptionCodeUtil',
    '../adapters/mixins/InputValueRecoverable',
    '../adapters/mixins/fields/DynamicSubscribe',
    '../adapters/mixins/fields/Email',
    '../adapters/mixins/fields/PasswordLengthValidation',
    './mixins/MemberEventTrackable',
    './mixins/NoCardDebugletable'
], 
function ( 
    ctor, 
    RSVP, 
    Checkout, 
    EFIDUserCreatable,
    SubscriptionsSavable,
    MemberCreatable,
    UpdateMemberInfoInMemberPage,
    MemberRedemptionCodeConsumable,
    EmailRegistrationValidatable,
    HasRedemptionCodeUtil,
    InputValueRecoverable,
    DynamicSubscribeField,
    EmailField,
    PasswordLengthValidationField,
    MemberEventTrackable,
    NoCardDebugletable
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply(me, arguments);

        me.mixin(
            EmailRegistrationValidatable,
            HasRedemptionCodeUtil,
            DynamicSubscribeField,
            EmailField,
            PasswordLengthValidationField,
            SubscriptionsSavable,
            EFIDUserCreatable,
            MemberCreatable,
            UpdateMemberInfoInMemberPage,
            MemberEventTrackable,
            InputValueRecoverable,
            NoCardDebugletable,
            // this mixin must be at last as it modifies the returning data from doSubmit
            MemberRedemptionCodeConsumable
        );
    }).inherit(Checkout); 

    return Ctor;
});
